export default __webpack_public_path__ + "static/media/icons-outline-start-tour-fill.44de689a.svg";